"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _default = function _default(hex, alpha) {
  var red = parseInt(hex.substring(1, 3), 16);
  var green = parseInt(hex.substring(3, 5), 16);
  var blue = parseInt(hex.substring(5, 7), 16);
  return "rgba(" + red + ", " + green + ", " + blue + ", " + alpha + ")";
};

exports["default"] = _default;